import { get, post, put } from "@/requests/server";
import i18n from "@/i18n";

export default {
  namespaced: true,
  state: {
    data: null,
    error: null,
    loaded: false,
    claiming: false,
  },
  mutations: {
    data(state, data) {
      state.data = data;
    },
    error(state, error) {
      state.error = error;
    },
    loaded(state, loaded) {
      state.loaded = loaded;
    },
    claiming(state, claiming) {
      state.claiming = claiming;
    },
    cancelToken(state, cancelToken) {
      state.cancelToken = cancelToken;
    },
  },
  actions: {
    async buyCredit({ commit, dispatch }, { amount, paymentMethodId }) {
      commit("loaded", false);
      const { data } = await put(
        "/auth/user/balance",
        {
          amount,
          payment_method_id: paymentMethodId,
        },
        {
          requestOptions: { cancelId: "add-to-balance" },
          notifications: { action: i18n.t("store.account.notifications.buy_credit.action") },
        }
      );

      commit("data", data);
      commit("loaded", true);
      dispatch("loadUser", {}, { root: true });
    },
    async claimCredit({ commit, dispatch }, { selected_amount }) {
      commit("loaded", false);
      commit("claiming", true);
      const { data } = await put(
        "/auth/user/claim",
        { selected_amount },
        {
          notifications: { action: i18n.t("store.account.notifications.claim_credit.action") },
          cleanupCallback: () => {
            commit("loaded", true);
            commit("claiming", false);
          },
        }
      );
      commit("data", data);
      dispatch("loadUser", {}, { root: true });
    },
    async mandate({ commit, dispatch }, { mandatedUserId }) {
      const response = await get(`/auth/password/mandate/${mandatedUserId}`);
      await commit("setTokens", { token: response.data, mandated: true }, { root: true });
      await dispatch("loadUser", {}, { root: true });
    },
    async resendEmailVerification() {
      await post(`/auth/resend_email_verification`);
    },
    async verifyEmail({ dispatch }, { id, code, params }) {
      await get(`/auth/verify_email/${id}/${code}`, {
        axiosRequestConfig: { params },
      });
      await dispatch("loadUser", {}, { root: true });
    },
  },
};
